const MuiFormControl = {
    root: {
        marginBottom: '10px',
    },
};
export default MuiFormControl;
